/**
 * Shortcut for `HTMLElement.hasAttribute()` method.
 * @param  {HTMLElement} element target element
 * @param  {string} attribute attribute name
 * @returns {boolean} the query result
 */
const hasAttribute = (element, attribute) => element.hasAttribute(attribute);

export default hasAttribute;
